// extracted by mini-css-extract-plugin
export default {"wrapper":"password_pin_wrapper__kkH0o","logo":"password_pin_logo__G18KN","btndiv":"password_pin_btndiv__SZrik","btn":"password_pin_btn__ZuNDF"};